var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _radialGradient2, _circle, _circle2, _ellipse, _path, _g, _circle3, _circle4, _path2, _circle5, _circle6, _path3, _circle7, _circle8, _path4, _circle9, _circle10, _path5, _circle11, _circle12, _path6, _circle13, _circle14, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAstrophysics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 223.292,
    cy: 209.57,
    gradientUnits: "userSpaceOnUse",
    r: 134.83
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffce3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffae2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.584,
    x2: 169.337,
    y1: 265.697,
    y2: 169.45
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.265,
    x2: 244.011,
    y1: 228.694,
    y2: 155.609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.285,
    x2: 388.71,
    y1: 291.468,
    y2: 48.896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.156,
    x2: 149.253,
    xlinkHref: "#lg1",
    y1: 227.277,
    y2: 267.373
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.454,
    x2: 105.352,
    xlinkHref: "#lg2",
    y1: 244.126,
    y2: 217.045
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.815,
    x2: 164.369,
    xlinkHref: "#lg3",
    y1: 250.725,
    y2: 171.58
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 422.094,
    x2: 462.191,
    xlinkHref: "#lg1",
    y1: 320.878,
    y2: 360.975
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.392,
    x2: 418.29,
    xlinkHref: "#lg2",
    y1: 337.728,
    y2: 310.646
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.753,
    x2: 477.307,
    xlinkHref: "#lg3",
    y1: 344.326,
    y2: 265.181
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.009,
    x2: 285.648,
    y1: 440.358,
    y2: 467.997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.554,
    x2: 255.387,
    y1: 451.972,
    y2: 433.305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9edf5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.898,
    x2: 298.231,
    y1: 452.497,
    y2: 397.941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.142,
    x2: 233.888,
    xlinkHref: "#lg4",
    y1: 422.704,
    y2: 472.449
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e1dc"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.121,
    x2: 179.423,
    xlinkHref: "#lg5",
    y1: 443.608,
    y2: 410.01
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.847,
    x2: 252.641,
    xlinkHref: "#lg6",
    y1: 451.795,
    y2: 353.604
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.687,
    x2: 489.428,
    y1: 49.689,
    y2: 118.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 446.913,
    x2: 414.166,
    y1: 78.575,
    y2: 32.148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee83"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.389,
    x2: 515.343,
    y1: 89.888,
    y2: -45.797
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.437,
    x2: 139.182,
    xlinkHref: "#lg4",
    y1: 47.077,
    y2: 96.823
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.416,
    x2: 84.718,
    xlinkHref: "#lg5",
    y1: 67.981,
    y2: 34.383
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.142,
    x2: 157.936,
    xlinkHref: "#lg6",
    y1: 76.168,
    y2: -22.023
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.472,
    x2: 103.019,
    xlinkHref: "#lg6",
    y1: 91.722,
    y2: 35.609
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 101.629,
    cy: 59.018,
    gradientTransform: "matrix(1 0 0 .2 0 47.204)",
    gradientUnits: "userSpaceOnUse",
    r: 69.125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3366,
    stopColor: "#ffd743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5734,
    stopColor: "#ffce3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "#ffbe35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9673,
    stopColor: "#ffa928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 254.99,
    cy: 255.103,
    fill: "url(#SVGID_1_)",
    r: 94.886
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.99,
    cy: 255.103,
    fill: "url(#SVGID_2_)",
    r: 88.763
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.99,
    cy: 202.113,
    fill: "url(#SVGID_3_)",
    rx: 57.576,
    ry: 33.466
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m297.435 170.224c6.4 12.772 10.007 27.186 10.007 42.445 0 52.404-42.482 94.886-94.885 94.886-15.259 0-29.673-3.607-42.445-10.007 15.579 31.093 47.733 52.44 84.879 52.44 52.404 0 94.886-42.482 94.886-94.885-.002-37.145-21.349-69.3-52.442-84.879z",
    fill: "url(#SVGID_4_)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7e8595"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m257.964 455.817c-4.456 0-8.101-3.577-8.169-8.048-.068-4.513 3.535-8.226 8.047-8.294 5.209-.079 10.465-.379 15.619-.891 4.494-.454 8.493 2.832 8.94 7.323s-2.832 8.494-7.323 8.94c-5.608.558-11.324.884-16.989.969-.041.001-.084.001-.125.001zm-53.847-6.768c-.713 0-1.438-.094-2.159-.292-5.45-1.489-10.908-3.234-16.222-5.186-4.236-1.557-6.409-6.252-4.852-10.488 1.556-4.237 6.253-6.406 10.489-4.853 4.879 1.793 9.89 3.395 14.894 4.763 4.353 1.19 6.918 5.683 5.729 10.037-.994 3.631-4.287 6.019-7.879 6.019zm122.865-7.114c-3.236 0-6.298-1.933-7.582-5.118-1.688-4.185.337-8.946 4.523-10.635 4.811-1.94 9.6-4.114 14.23-6.459 4.028-2.038 8.944-.428 10.983 3.6 2.039 4.026.428 8.942-3.599 10.982-5.045 2.554-10.26 4.921-15.503 7.035-1.001.403-2.035.595-3.052.595zm-186.224-23.616c-1.685 0-3.386-.519-4.846-1.597-4.549-3.356-9.011-6.95-13.263-10.682-3.392-2.977-3.728-8.14-.751-11.532s8.14-3.728 11.532-.751c3.907 3.428 8.007 6.731 12.186 9.815 3.631 2.68 4.402 7.796 1.723 11.428-1.602 2.171-4.075 3.319-6.581 3.319zm245.584-14.23c-2.185 0-4.366-.871-5.974-2.595-3.08-3.298-2.904-8.47.396-11.549 3.803-3.552 7.497-7.303 10.981-11.152 3.03-3.345 8.197-3.601 11.543-.575 3.345 3.029 3.603 8.196.575 11.543-3.789 4.186-7.808 8.267-11.945 12.129-1.576 1.472-3.578 2.199-5.576 2.199zm-293.679-37.189c-2.694 0-5.331-1.331-6.891-3.769-3.05-4.769-5.929-9.721-8.557-14.719-2.1-3.994-.565-8.936 3.43-11.036 3.995-2.097 8.936-.563 11.036 3.43 2.413 4.589 5.057 9.137 7.859 13.516 2.432 3.802 1.322 8.856-2.48 11.288-1.365.873-2.89 1.29-4.397 1.29zm335.548-19.42c-1.2 0-2.42-.266-3.572-.827-4.057-1.977-5.745-6.867-3.769-10.925 2.277-4.675 4.378-9.501 6.245-14.344 1.623-4.211 6.35-6.312 10.563-4.687 4.211 1.623 6.31 6.351 4.687 10.563-2.032 5.276-4.321 10.533-6.8 15.625-1.416 2.904-4.326 4.595-7.354 4.595zm-361.972-45.834c-3.809 0-7.217-2.677-8.001-6.554-1.119-5.532-2.014-11.19-2.661-16.818-.516-4.483 2.701-8.536 7.184-9.052 4.484-.514 8.537 2.702 9.052 7.185.595 5.169 1.417 10.366 2.444 15.445.895 4.423-1.966 8.735-6.389 9.629-.547.111-1.092.165-1.629.165zm380.644-22.056c-.23 0-.46-.01-.693-.029-4.498-.377-7.838-4.328-7.46-8.826.433-5.161.652-10.42.652-15.633 0-2.058-.034-4.136-.101-6.177-.148-4.51 3.389-8.288 7.899-8.436 4.48-.144 8.288 3.388 8.436 7.899.072 2.218.11 4.477.11 6.713 0 5.666-.238 11.385-.71 16.999-.357 4.266-3.93 7.49-8.133 7.49zm-381.798-48.337c-.448 0-.902-.037-1.359-.113-4.451-.746-7.456-4.958-6.71-9.409.934-5.581 2.12-11.186 3.524-16.66 1.121-4.371 5.577-7.004 9.945-5.885 4.372 1.121 7.007 5.574 5.885 9.945-1.289 5.026-2.378 10.174-3.236 15.299-.668 3.993-4.129 6.823-8.049 6.823zm372.969-27.879c-3.44 0-6.64-2.189-7.766-5.635-1.61-4.924-3.455-9.846-5.485-14.629-1.764-4.154.174-8.952 4.328-10.715 4.153-1.764 8.953.173 10.715 4.328 2.212 5.209 4.223 10.572 5.977 15.938 1.402 4.29-.938 8.904-5.229 10.306-.843.276-1.699.407-2.54.407zm-348.789-38.237c-1.419 0-2.855-.369-4.164-1.146-3.881-2.304-5.159-7.316-2.856-11.198 2.886-4.863 6.017-9.662 9.305-14.264 2.623-3.674 7.727-4.523 11.399-1.899s4.522 7.727 1.899 11.4c-3.021 4.228-5.897 8.638-8.549 13.106-1.526 2.572-4.244 4.001-7.034 4.001zm315.008-23.517c-2.371 0-4.722-1.026-6.337-3.006-3.281-4.023-6.779-7.957-10.393-11.694-3.138-3.244-3.052-8.417.192-11.555 3.244-3.139 8.416-3.051 11.555.192 3.934 4.067 7.739 8.348 11.311 12.726 2.853 3.497 2.33 8.645-1.166 11.498-1.518 1.237-3.346 1.839-5.162 1.839zm-268.623-29.477c-2.413 0-4.802-1.063-6.415-3.103-2.799-3.54-2.199-8.679 1.341-11.479 4.438-3.509 9.077-6.869 13.788-9.986 3.762-2.492 8.833-1.459 11.324 2.306 2.49 3.765 1.458 8.835-2.306 11.324-4.328 2.863-8.59 5.95-12.668 9.175-1.501 1.187-3.289 1.763-5.064 1.763zm214.915-16.074c-1.378 0-2.774-.348-4.055-1.082-4.509-2.583-9.184-5.004-13.895-7.194-4.092-1.902-5.867-6.762-3.965-10.855 1.902-4.092 6.761-5.867 10.855-3.965 5.129 2.384 10.219 5.019 15.129 7.832 3.916 2.243 5.271 7.236 3.028 11.153-1.509 2.636-4.264 4.111-7.097 4.111zm-152.646-16.761c-3.487 0-6.717-2.249-7.803-5.755-1.336-4.31 1.076-8.888 5.387-10.224 5.398-1.673 10.939-3.132 16.469-4.34 4.406-.964 8.764 1.831 9.727 6.241.962 4.409-1.832 8.763-6.241 9.726-5.076 1.109-10.162 2.449-15.117 3.985-.806.248-1.621.367-2.422.367zm86.173-6.414c-.408 0-.819-.031-1.234-.094-5.133-.777-10.365-1.345-15.551-1.686-4.503-.296-7.913-4.187-7.616-8.691.296-4.503 4.182-7.927 8.691-7.616 5.644.371 11.338.988 16.923 1.835 4.462.676 7.532 4.841 6.855 9.303-.613 4.047-4.097 6.949-8.068 6.949z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.434 509.505c-4.254 0-7.842-3.294-8.143-7.602-.315-4.502 3.079-8.407 7.582-8.721 5.24-.366 10.526-.911 15.711-1.618 4.463-.628 8.592 2.52 9.202 6.991.611 4.472-2.52 8.592-6.991 9.202-5.539.757-11.186 1.339-16.784 1.729-.193.013-.385.019-.577.019zm-54.29-2.123c-.403 0-.81-.03-1.22-.092-5.547-.83-11.132-1.857-16.599-3.052-4.409-.963-7.203-5.318-6.239-9.727.963-4.409 5.319-7.204 9.727-6.239 5.115 1.117 10.341 2.078 15.532 2.856 4.463.668 7.54 4.829 6.871 9.291-.608 4.054-4.095 6.963-8.072 6.963zm123.254-12.813c-3.312 0-6.428-2.028-7.656-5.313-1.58-4.227.566-8.936 4.793-10.516 4.908-1.834 9.814-3.856 14.579-6.009 4.117-1.863 8.954-.03 10.81 4.084 1.858 4.112.03 8.953-4.084 10.81-5.095 2.301-10.337 4.463-15.584 6.423-.941.354-1.908.521-2.858.521zm-190.833-7.563c-1.159 0-2.336-.248-3.455-.771-5.079-2.375-10.146-4.952-15.06-7.662-3.952-2.179-5.39-7.149-3.211-11.101 2.18-3.952 7.15-5.39 11.101-3.21 4.598 2.535 9.339 4.947 14.09 7.168 4.089 1.911 5.853 6.775 3.942 10.864-1.387 2.968-4.333 4.712-7.407 4.712zm252.672-26.347c-2.481 0-4.932-1.125-6.538-3.261-2.712-3.607-1.985-8.73 1.622-11.443 4.181-3.143 8.32-6.475 12.301-9.903 3.419-2.944 8.578-2.56 11.524.861 2.945 3.421 2.559 8.58-.861 11.524-4.254 3.662-8.676 7.223-13.144 10.582-1.472 1.106-3.195 1.64-4.904 1.64zm-311.676-12.39c-1.924 0-3.855-.676-5.41-2.049-4.194-3.708-8.322-7.608-12.268-11.588-3.178-3.205-3.155-8.379.05-11.556 3.205-3.178 8.379-3.156 11.556.05 3.696 3.728 7.56 7.378 11.487 10.85 3.381 2.99 3.699 8.154.709 11.535-1.614 1.826-3.864 2.758-6.124 2.758zm361.45-37.612c-1.698 0-3.411-.527-4.878-1.621-3.619-2.697-4.365-7.817-1.667-11.435 3.135-4.205 6.17-8.571 9.024-12.977 2.454-3.79 7.513-4.869 11.3-2.419 3.789 2.454 4.871 7.513 2.417 11.301-3.047 4.707-6.29 9.371-9.639 13.862-1.603 2.153-4.065 3.289-6.557 3.289zm-407.123-16.162c-2.716 0-5.373-1.353-6.925-3.823-2.98-4.739-5.839-9.639-8.5-14.564-2.145-3.971-.664-8.928 3.306-11.073 3.971-2.144 8.929-.665 11.073 3.306 2.49 4.61 5.167 9.197 7.956 13.632 2.403 3.821 1.252 8.865-2.568 11.268-1.351.849-2.856 1.254-4.342 1.254zm440.786-45.873c-.938 0-1.893-.163-2.825-.506-4.235-1.561-6.402-6.259-4.841-10.493 1.811-4.914 3.48-9.957 4.963-14.989 1.275-4.33 5.815-6.811 10.147-5.531 4.33 1.275 6.806 5.817 5.531 10.147-1.583 5.38-3.369 10.771-5.305 16.025-1.218 3.302-4.344 5.347-7.67 5.347zm-469.402-18.614c-3.573 0-6.853-2.361-7.865-5.97-1.511-5.396-2.86-10.912-4.009-16.395-.925-4.418 1.906-8.748 6.323-9.674 4.422-.921 8.748 1.907 9.674 6.324 1.074 5.129 2.336 10.289 3.75 15.337 1.217 4.347-1.319 8.856-5.665 10.073-.736.206-1.478.305-2.208.305zm484.033-50.409c-.179 0-.359-.005-.539-.017-4.504-.295-7.916-4.184-7.623-8.687.342-5.221.514-10.535.514-15.792 0-4.514 3.658-8.172 8.172-8.172s8.172 3.658 8.172 8.172c0 5.612-.184 11.283-.548 16.856-.284 4.323-3.877 7.64-8.148 7.64zm-493.131-19.556c-.036 0-.071 0-.107-.001-4.513-.057-8.124-3.762-8.066-8.275.072-5.614.33-11.284.767-16.851.353-4.499 4.3-7.852 8.786-7.508 4.499.353 7.86 4.287 7.508 8.787-.409 5.213-.651 10.522-.718 15.781-.058 4.477-3.706 8.067-8.17 8.067zm489.044-44.448c-3.829 0-7.248-2.704-8.011-6.603-1.008-5.149-2.201-10.326-3.546-15.387-1.16-4.361 1.436-8.837 5.798-9.996 4.36-1.161 8.837 1.436 9.997 5.798 1.439 5.409 2.713 10.942 3.791 16.447.867 4.428-2.021 8.722-6.45 9.589-.531.102-1.059.152-1.579.152zm-478.112-25.252c-.799 0-1.61-.118-2.414-.366-4.312-1.331-6.728-5.906-5.397-10.219 1.656-5.363 3.515-10.739 5.525-15.98 1.617-4.214 6.341-6.323 10.557-4.702 4.214 1.616 6.319 6.343 4.702 10.556-1.881 4.902-3.62 9.932-5.169 14.947-1.082 3.51-4.314 5.764-7.804 5.764zm454.753-41.317c-2.944 0-5.788-1.596-7.247-4.387-2.427-4.64-5.042-9.26-7.774-13.732-2.353-3.852-1.137-8.881 2.714-11.233 3.852-2.353 8.88-1.139 11.233 2.714 2.92 4.78 5.715 9.718 8.308 14.677 2.092 3.999.546 8.937-3.454 11.028-1.208.633-2.503.933-3.78.933zm-424.447-22.436c-1.557 0-3.13-.444-4.523-1.372-3.756-2.503-4.772-7.576-2.27-11.332 3.103-4.657 6.406-9.278 9.82-13.733 2.744-3.584 7.873-4.261 11.456-1.518 3.583 2.745 4.262 7.874 1.517 11.456-3.195 4.171-6.288 8.497-9.192 12.857-1.574 2.363-4.166 3.642-6.808 3.642zm383.157-34.766c-2.14 0-4.276-.835-5.88-2.496-3.641-3.77-7.458-7.471-11.344-10.998-3.341-3.034-3.591-8.201-.559-11.544 3.035-3.343 8.203-3.591 11.544-.559 4.151 3.768 8.227 7.721 12.116 11.749 3.135 3.246 3.044 8.42-.202 11.554-1.586 1.532-3.632 2.294-5.675 2.294zm-336.055-17.801c-2.333 0-4.65-.994-6.267-2.922-2.899-3.459-2.446-8.613 1.013-11.513 4.291-3.596 8.758-7.098 13.276-10.405 3.641-2.665 8.755-1.875 11.421 1.767 2.666 3.641 1.875 8.755-1.767 11.42-4.231 3.097-8.414 6.376-12.432 9.743-1.529 1.283-3.392 1.91-5.244 1.91zm280.301-25.473c-1.369 0-2.757-.344-4.033-1.069-4.561-2.594-9.27-5.069-13.994-7.355-4.062-1.965-5.763-6.851-3.796-10.915 1.963-4.062 6.85-5.762 10.915-3.798 5.049 2.443 10.081 5.087 14.956 7.86 3.923 2.231 5.295 7.22 3.063 11.144-1.506 2.648-4.268 4.133-7.111 4.133zm-220.334-11.669c-3.153 0-6.155-1.834-7.496-4.909-1.803-4.137.089-8.953 4.226-10.755 5.127-2.234 10.398-4.326 15.667-6.216 4.25-1.524 8.928.685 10.451 4.933 1.524 4.249-.685 8.927-4.933 10.451-4.929 1.768-9.86 3.724-14.655 5.814-1.062.463-2.171.682-3.26.682zm154.61-14.042c-.613 0-1.234-.069-1.856-.214-5.109-1.186-10.322-2.216-15.493-3.06-4.454-.728-7.475-4.929-6.748-9.383.727-4.452 4.913-7.471 9.383-6.748 5.525.902 11.096 2.002 16.555 3.271 4.397 1.02 7.132 5.413 6.112 9.808-.877 3.775-4.238 6.326-7.953 6.326zm-86.586-4.539c-4.067 0-7.59-3.034-8.1-7.174-.552-4.48 2.632-8.558 7.111-9.109 5.537-.683 11.19-1.191 16.801-1.511 4.517-.238 8.367 3.188 8.623 7.694.257 4.506-3.188 8.366-7.693 8.624-5.256.299-10.549.775-15.733 1.413-.339.043-.676.063-1.009.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.502 397.516c-.03 0-.06 0-.09 0-5.772-.063-11.582-.477-17.27-1.229-4.474-.593-7.621-4.7-7.028-9.174.592-4.475 4.7-7.623 9.173-7.029 5.038.667 10.186 1.034 15.302 1.088 4.513.049 8.131 3.747 8.083 8.26-.049 4.483-3.699 8.084-8.17 8.084zm53.103-10.269c-3.201 0-6.237-1.892-7.546-5.03-1.736-4.166.233-8.951 4.399-10.687 4.7-1.959 9.327-4.228 13.755-6.747 3.923-2.23 8.912-.86 11.144 3.063 2.231 3.923.86 8.912-3.063 11.143-5.004 2.846-10.235 5.412-15.546 7.626-1.029.429-2.094.632-3.143.632zm-120.473-8.696c-1.428 0-2.874-.375-4.189-1.161-4.94-2.957-9.751-6.25-14.298-9.787-3.562-2.771-4.204-7.905-1.434-11.467 2.771-3.561 7.905-4.203 11.468-1.433 4.026 3.13 8.284 6.046 12.659 8.663 3.872 2.319 5.132 7.336 2.815 11.208-1.532 2.558-4.241 3.977-7.021 3.977zm175.809-34.13c-1.724 0-3.46-.543-4.938-1.666-3.593-2.73-4.292-7.857-1.561-11.45 3.087-4.061 5.954-8.353 8.523-12.754 2.275-3.9 7.28-5.216 11.175-2.94 3.899 2.274 5.215 7.278 2.941 11.175-2.902 4.973-6.142 9.821-9.628 14.408-1.608 2.115-4.045 3.227-6.512 3.227zm-224.457-16.181c-2.875 0-5.663-1.519-7.155-4.212-2.794-5.04-5.301-10.3-7.453-15.633-1.689-4.185.335-8.946 4.519-10.636 4.185-1.689 8.947.333 10.637 4.52 1.903 4.716 4.122 9.368 6.592 13.828 2.188 3.948.761 8.921-3.187 11.108-1.255.696-2.614 1.025-3.953 1.025zm250.787-48.667c-.328 0-.659-.02-.992-.061-4.481-.542-7.674-4.613-7.131-9.093.61-5.048.919-10.201.919-15.317 0-4.514 3.658-8.172 8.172-8.172s8.172 3.658 8.172 8.172c0 5.769-.349 11.582-1.038 17.279-.501 4.148-4.026 7.192-8.102 7.192zm-267.496-19.278c-.06 0-.121-.001-.181-.002-4.512-.098-8.09-3.836-7.991-8.347.126-5.772.603-11.579 1.419-17.256.642-4.468 4.78-7.572 9.251-6.927 4.467.642 7.568 4.784 6.927 9.251-.722 5.029-1.145 10.172-1.257 15.288-.098 4.451-3.738 7.993-8.168 7.993zm259.841-44.469c-3.301 0-6.409-2.014-7.645-5.284-1.8-4.764-3.916-9.468-6.287-13.983-2.099-3.995-.561-8.936 3.435-11.034 3.995-2.101 8.936-.562 11.034 3.435 2.68 5.102 5.071 10.419 7.107 15.803 1.596 4.222-.533 8.938-4.754 10.534-.953.359-1.929.529-2.89.529zm-240.137-22.674c-1.457 0-2.932-.389-4.266-1.208-3.847-2.361-5.051-7.393-2.691-11.239 3.011-4.906 6.356-9.679 9.942-14.189 2.81-3.531 7.95-4.118 11.482-1.308 3.532 2.809 4.118 7.949 1.308 11.482-3.176 3.992-6.137 8.219-8.803 12.563-1.541 2.514-4.224 3.899-6.972 3.899zm199.166-34.074c-1.812 0-3.636-.599-5.151-1.832-3.961-3.222-8.156-6.231-12.466-8.942-3.821-2.404-4.969-7.448-2.566-11.268 2.404-3.821 7.449-4.97 11.268-2.566 4.869 3.063 9.605 6.46 14.077 10.098 3.502 2.847 4.031 7.995 1.183 11.496-1.616 1.984-3.971 3.014-6.345 3.014zm-148.305-14.032c-2.907 0-5.721-1.555-7.199-4.292-2.143-3.971-.661-8.928 3.31-11.072 5.068-2.735 10.355-5.183 15.714-7.277 4.203-1.646 8.943.433 10.586 4.637 1.642 4.203-.434 8.942-4.637 10.585-4.74 1.852-9.417 4.019-13.9 6.438-1.235.665-2.564.981-3.874.981zm84.384-14.43c-.416 0-.838-.032-1.263-.098-5.018-.779-10.155-1.258-15.27-1.425-4.51-.147-8.048-3.923-7.9-8.435.147-4.51 3.891-8.063 8.435-7.9 5.772.188 11.573.73 17.242 1.61 4.459.692 7.514 4.868 6.821 9.328-.625 4.036-4.104 6.92-8.065 6.92z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.739,
    cy: 238.86,
    fill: "url(#SVGID_5_)",
    r: 30.959
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.739,
    cy: 238.86,
    fill: "url(#SVGID_6_)",
    r: 25.838
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m134.588 211.166c2.088 4.167 3.265 8.87 3.265 13.849 0 17.098-13.861 30.959-30.959 30.959-4.978 0-9.682-1.177-13.849-3.265 5.083 10.145 15.574 17.11 27.694 17.11 17.098 0 30.959-13.861 30.959-30.959 0-12.12-6.965-22.611-17.11-27.694z",
    fill: "url(#SVGID_7_)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 433.678,
    cy: 332.461,
    fill: "url(#SVGID_8_)",
    r: 30.959
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 433.678,
    cy: 332.461,
    fill: "url(#SVGID_9_)",
    r: 25.838
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m447.526 304.768c2.088 4.167 3.265 8.87 3.265 13.849 0 17.098-13.861 30.959-30.959 30.959-4.978 0-9.682-1.177-13.849-3.265 5.083 10.145 15.574 17.11 27.694 17.11 17.098 0 30.959-13.861 30.959-30.959.001-12.12-6.965-22.611-17.11-27.694z",
    fill: "url(#SVGID_10_)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.993,
    cy: 448.343,
    fill: "url(#SVGID_11_)",
    r: 21.34
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.993,
    cy: 448.343,
    fill: "url(#SVGID_12_)",
    r: 17.81
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m275.539 429.253c1.439 2.873 2.251 6.114 2.251 9.546 0 11.786-9.554 21.34-21.34 21.34-3.432 0-6.674-.811-9.546-2.251 3.504 6.993 10.735 11.794 19.09 11.794 11.786 0 21.34-9.554 21.34-21.34-.001-8.353-4.802-15.585-11.795-19.089z",
    fill: "url(#SVGID_13_)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.513,
    cy: 437.075,
    fill: "url(#SVGID_14_)",
    r: 38.409
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.513,
    cy: 437.075,
    fill: "url(#SVGID_15_)",
    r: 32.055
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m215.694 402.717c2.59 5.17 4.051 11.005 4.051 17.181 0 21.213-17.196 38.409-38.409 38.409-6.176 0-12.011-1.46-17.181-4.051 6.306 12.586 19.322 21.227 34.358 21.227 21.213 0 38.409-17.196 38.409-38.409 0-15.035-8.642-28.051-21.228-34.357z",
    fill: "url(#SVGID_16_)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 440.545,
    cy: 69.547,
    fill: "url(#SVGID_17_)",
    r: 53.075
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 440.545,
    cy: 69.547,
    fill: "url(#SVGID_18_)",
    r: 44.296
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m464.287 22.069c3.58 7.144 5.598 15.207 5.598 23.742 0 29.313-23.763 53.075-53.075 53.075-8.535 0-16.598-2.018-23.742-5.598 8.714 17.392 26.7 29.333 47.478 29.333 29.313 0 53.075-23.762 53.075-53.075 0-20.776-11.941-38.762-29.334-47.477z",
    fill: "url(#SVGID_19_)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.808,
    cy: 61.448,
    fill: "url(#SVGID_20_)",
    r: 38.409
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.808,
    cy: 61.448,
    fill: "url(#SVGID_21_)",
    r: 32.055
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m120.989 27.09c2.59 5.17 4.051 11.005 4.051 17.181 0 21.213-17.196 38.409-38.409 38.409-6.176 0-12.011-1.46-17.181-4.051 6.306 12.586 19.322 21.227 34.358 21.227 21.213 0 38.409-17.196 38.409-38.409-.001-15.035-8.642-28.051-21.228-34.357z",
    fill: "url(#SVGID_22_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m65.685 66.064c.228 1.9.593 3.757 1.087 5.561l26.858 26.858c3.243.889 6.652 1.373 10.177 1.373 19.649 0 35.841-14.758 38.123-33.792z",
    fill: "url(#SVGID_23_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m140.858 51.289c.458 1.667.806 3.389 1.046 5.154 7.605.643 12.192 1.482 12.192 2.408 0 .915-4.467 1.743-11.876 2.375-9.229.806-23.012 1.307-38.418 1.307s-29.189-.501-38.407-1.307c-7.409-.632-11.876-1.46-11.876-2.375 0-.926 4.598-1.765 12.192-2.397.24-1.765.577-3.487 1.046-5.165-17.978 2.19-29.821 5.916-29.821 10.155 0 4.238 11.844 7.976 29.821 10.166 10.601 1.286 23.349 2.037 37.045 2.037 13.707 0 26.455-.752 37.056-2.037 17.978-2.19 29.821-5.927 29.821-10.166.001-4.238-11.843-7.964-29.821-10.155z",
    fill: "url(#SVGID_24_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAstrophysics);
export default __webpack_public_path__ + "static/media/icon-astrophysics.e92351ea9cdf8b933d17ccf48f28e0e2.svg";
export { ForwardRef as ReactComponent };